import { render, staticRenderFns } from "./DriversDetails.vue?vue&type=template&id=17ec3a0c&"
import script from "./DriversDetails.vue?vue&type=script&lang=js&"
export * from "./DriversDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports